module.exports = __webpack_public_path__ + "static/index/img/baikal-703.c3840a02.jpg";